import { FC } from "react";

import { MAPLIBRE_POLYGON_ICON_SIZE_PX } from "./maplibre-polygon-editor.constants";
import { IMapLibrePolygonToolIconProps } from "./maplibre-polygon-editor.models";

/**
 * One of the toolbar's five glyphs, traced straight out of the icons Leaflet-geoman shipped so the toolbar
 * reads exactly as it did. The artwork is drawn on a 30x30 grid inset by 3, hence the group transform; the
 * scissors are additionally rotated about their own centre, which is what `pathTransform` carries.
 */
export const MapLibrePolygonToolIcon: FC<IMapLibrePolygonToolIconProps> = ({
  path,
  pathTransform,
}) => (
  <svg
    width={MAPLIBRE_POLYGON_ICON_SIZE_PX}
    height={MAPLIBRE_POLYGON_ICON_SIZE_PX}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <g transform="translate(-3 -3)">
      <path fillRule="nonzero" transform={pathTransform} d={path} />
    </g>
  </svg>
);
